import {LISTING_SECTION_IDS} from '../common/listingSections.js'
import {
  AD_DETAIL_RESERVATION_HASHES as sharedAdDetailReservationHashes,
  ADS_LIST_PAGE_NAMES as sharedAdsListPageNames,
  PAGE_NAMES_BY_LISTING_SECTION_ID as sharedPageNamesByListingSectionId
} from '../common/page.js'
import {
  AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID,
  CARS_WITHOUT_LICENSE_CATEGORY1_ID,
  CLASSIC_AND_COMPETITION_CATEGORY1_ID,
  FUEL_TYPE_CNG_ID,
  FUEL_TYPE_DIESEL_ID,
  FUEL_TYPE_ELECTRIC_ID,
  FUEL_TYPE_GASOLINE_ID,
  FUEL_TYPE_GLP_ID,
  FUEL_TYPE_HYBRID_ID,
  FUEL_TYPE_HYBRID_PLUG_IN_ID,
  SEGUNDA_MANO_CATEGORY1_ID,
  VANS_AND_COMMERCIAL_CATEGORY1_ID
} from './ads.js'
import {TARGET_BUYER, VEHICLE_STATE_IDS} from './subscription.js'

export const VEHICLE_STATE_ID_SLUG_MAPPING = {
  [VEHICLE_STATE_IDS.NEW]: 'nuevo',
  [VEHICLE_STATE_IDS.USED]: 'segunda-mano'
}

export const TARGET_BUYER_SLUG_MAPPING = {
  [TARGET_BUYER.PRIVATES]: 'particulares',
  [TARGET_BUYER.BUSINESS]: 'empresas'
}

export const VEHICLE_TYPE_SLUG_MAPPING = {
  furgonetas: 'furgonetas'
}

export const VEHICLE_TYPE_CATEGORY1_ID_MAPPING = {
  [VEHICLE_TYPE_SLUG_MAPPING.furgonetas]: VANS_AND_COMMERCIAL_CATEGORY1_ID
}

export const FUEL_TYPE_ID_SLUG_MAPPING = {
  [FUEL_TYPE_CNG_ID]: 'gas_natural',
  [FUEL_TYPE_DIESEL_ID]: 'diesel',
  [FUEL_TYPE_ELECTRIC_ID]: 'electrico',
  [FUEL_TYPE_GASOLINE_ID]: 'gasolina',
  [FUEL_TYPE_GLP_ID]: 'gas_glp',
  [FUEL_TYPE_HYBRID_ID]: 'hibrido',
  [FUEL_TYPE_HYBRID_PLUG_IN_ID]: 'hibrido_enchufable'
}

export const FUEL_TYPE_NAME_MAPPING = {
  [FUEL_TYPE_CNG_ID]: 'Gas natural',
  [FUEL_TYPE_DIESEL_ID]: 'Diesel',
  [FUEL_TYPE_ELECTRIC_ID]: 'Eléctrico',
  [FUEL_TYPE_GASOLINE_ID]: 'Gasolina',
  [FUEL_TYPE_GLP_ID]: 'Gas GLP',
  [FUEL_TYPE_HYBRID_ID]: 'Híbrido',
  [FUEL_TYPE_HYBRID_PLUG_IN_ID]: 'Híbrido enchufable'
}

export const SECTION_ID_MAPPING = {
  [SEGUNDA_MANO_CATEGORY1_ID]: 'cars',
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: 'commercial',
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: 'autocaravans',
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: 'without_license',
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: 'classics'
}

export const PAGINATION_PLACEHOLDER = '%{pg}'

export const PAGINATION_PATTERN = 'pg='
export const QUERY_SEARCH_PATTERN = 'q='
export const QUESTION_MARK = '?'
export const AMPERSAND_MARK = '&'
export const WILDCARD_MARK = '*'
export const PARAMS_PATTERN = `[${QUESTION_MARK}|${AMPERSAND_MARK}]`

export const HOME_PATH_PATTERN = '/'
export const AB_HOME_PATH_PATTERN = '/home.htm'

export const LOGIN_PATH_PATTERN = '/login'
export const LOGIN_WITH_LOGIN_SCREEN_PATH_PATTERN = `${LOGIN_PATH_PATTERN}/?p=l`
export const LOGIN_WITH_REGISTER_SCREEN_PATH_PATTERN = `${LOGIN_PATH_PATTERN}/?p=r`
export const AB_LOGIN_PATH_PATTERN = '/login.htm'

export const TERMS_OF_SERVICE_PATH_PATTERN = '/condiciones-de-uso'
export const TRANSPARENCY_PATH_PATTERN = '/transparencia/'
export const TERMS_OF_SERVICE_RESERVATION_PATH_PATTERN = '/condiciones-de-uso-reserva'
export const DATA_PROTECTION_PATH_PATTERN = `${TERMS_OF_SERVICE_PATH_PATTERN}/#proteccion-datos`
export const SORT_MANAGEMENT_TERMS_PATH_PATTERN = `${TERMS_OF_SERVICE_PATH_PATTERN}/#8-principales-parametros-de-clasificacion-de-los-resultados-de-busquedas-y-sistemas-de-recomendacion`
export const OTHER_PARTNERS_PATH_PATTERN = '/cookies-otros-partners'

export const PTA_PATH_PATTERN = '/vender-mi-coche'
export const PTA_WITH_PLATE_PATH_PATTERN = '/vender-mi-coche-con-matricula'
export const PTA_OTHER_CATEGORIES_PATH_PATTERN = '/vender-mi-vehiculo.aspx'
export const PRODUCTS_PATH_PATTERN = '/products/'

export const ADS_LIST_SEARCH_PATH_PATTERN = '/search/'
export const SECOND_HAND_PATH_PATTERN = '/segunda-mano/'
export const KM0_PATH_PATTERN = '/km-0/'
export const NEW_KM0_PATH_PATTERN = `/nuevo${KM0_PATH_PATTERN}`
export const ADS_LIST_BUSINESS_SUBSCRIPTION_PATH_PATTERN = '/renting/empresas/'
export const ADS_LIST_SUBSCRIPTION_PATH_PATTERN = '/renting/'
export const ADS_LIST_SUBSCRIPTION_PATH_PATTERN_WITHOUT_SLASH = '/renting'
export const ADS_LIST_SUBSCRIPTION_PATH_PATTERN_WITH_REGEX =
  /^\/renting(\/)?([A-z0-9\-&]*)(\/)?([A-z0-9\-&]*)(\/(opiniones|informacion))?\/?$/

export const ADS_LIST_SEMANTIC_PRIVATE_SELLER = 'ads-list-semantic-private-seller'
export const ADS_LIST_SEMANTIC_VANS = 'ads-list-semantic-vans'
export const ADS_LIST_SEMANTIC_TRACTORS = 'ads-list-semantic-tractors'
export const ADS_LIST_SEMANTIC_SEVEN_SEATS = 'ads-list-semantic-seven-seats'
export const ADS_LIST_SEMANTIC_AUTOMATIC = 'ads-list-semantic-automatic'
export const ADS_LIST_SEMANTIC_YEAR = 'ads-list-semantic-year'
export const ADS_LIST_SEMANTIC_MAX_PRICE = 'ads-list-semantic-max-price'
export const ADS_LIST_SEMANTIC_CAMPERVAN = 'ads-list-semantic-campervan'
export const ADS_LIST_SEMANTIC_CAR_TRAILER = 'ads-list-semantic-car-trailer'
export const ADS_LIST_SEMANTIC_CHEAP_VANS = 'ads-list-semantic-cheap-vans'
export const ADS_LIST_SEMANTIC_CLASSIC_COMPETITION = 'ads-list-semantic-classic-competition'
export const ADS_LIST_SEMANTIC_TRUCKS = 'ads-list-semantic-trucks'
export const ADS_LIST_SEMANTIC_BUSES = 'ads-list-semantic-buses'
export const ADS_LIST_SEMANTIC_FINANCED = 'ads-list-semantic-financed'
export const ADS_LIST_SEMANTIC_COLOR = 'ads-list-semantic-color'
export const ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE = 'ads-list-semantic-cars-without-license'
export const ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL = 'ads-list-semantic-environmental-label'
export const ADS_LIST_SEMANTIC_LIFESTYLE = 'ads-list-semantic-lifestyle'

export const ADS_LIST_SEMANTIC_VANS_REGEX = /\/vehiculos-industriales\/furgonetas\/(\w+)?/
export const ADS_LIST_SEMANTIC_TRACTORS_REGEX = /\/vehiculos-industriales\/tractores\//
export const ADS_LIST_SEMANTIC_PRIVATE_SELLER_REGEX = /particulares/
export const ADS_LIST_SEMANTIC_SEVEN_SEATS_REGEX = /7_plazas/
export const ADS_LIST_SEMANTIC_AUTOMATIC_REGEX = /automatico/
export const ADS_LIST_SEMANTIC_YEAR_REGEX = /\/(19|20)\d{2}\// // .../2021/
export const ADS_LIST_SEMANTIC_CHEAP_NEW_REGEX = /\/nuevo\/baratos\/?$/
export const ADS_LIST_SEMANTIC_MAX_PRICE_REGEX = /\d(_euros)/ // .../7000_euros/
export const ADS_LIST_SEMANTIC_CAMPERVAN_REGEX = /campers\//
export const ADS_LIST_SEMANTIC_CAR_TRAILER_REGEX = /\/remolques\//
export const ADS_LIST_SEMANTIC_CHEAP_VANS_REGEX = /\/vehiculos-industriales\/baratos\//
export const ADS_LIST_SEMANTIC_CLASSIC_COMPETITION_REGEX = /\w+\/clasicos-competicion\//
export const ADS_LIST_SEMANTIC_TRUCKS_REGEX = /\/camiones\//
export const ADS_LIST_SEMANTIC_BUSES_REGEX = /\/autobuses\//
const ADS_LIST_SEMANTIC_FINANCED_REGEX = /\/financiados(-sin-entrada)?\//
const ADS_LIST_SEMANTIC_COLOR_REGEX = /\/color_[a-z_]+\//
export const ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE_REGEX = /\/sin-carnet\//
const ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL_REGEX = /\/etiqueta-(eco|cero)\//
const ADS_LIST_SEMANTIC_LIFESTYLE_REGEX =
  /\/(coches-para-familias|coches-para-ciudad|coches-pequenos|coches-bajas-emisiones|primer-coche-conductor-novel)\//

export const ADS_LIST_SEMANTIC_REGEXS = {
  [ADS_LIST_SEMANTIC_VANS]: ADS_LIST_SEMANTIC_VANS_REGEX,
  [ADS_LIST_SEMANTIC_PRIVATE_SELLER]: ADS_LIST_SEMANTIC_PRIVATE_SELLER_REGEX,
  [ADS_LIST_SEMANTIC_TRACTORS]: ADS_LIST_SEMANTIC_TRACTORS_REGEX,
  [ADS_LIST_SEMANTIC_SEVEN_SEATS]: ADS_LIST_SEMANTIC_SEVEN_SEATS_REGEX,
  [ADS_LIST_SEMANTIC_AUTOMATIC]: ADS_LIST_SEMANTIC_AUTOMATIC_REGEX,
  [ADS_LIST_SEMANTIC_YEAR]: ADS_LIST_SEMANTIC_YEAR_REGEX,
  [ADS_LIST_SEMANTIC_MAX_PRICE]: ADS_LIST_SEMANTIC_MAX_PRICE_REGEX,
  [ADS_LIST_SEMANTIC_CAMPERVAN]: ADS_LIST_SEMANTIC_CAMPERVAN_REGEX,
  [ADS_LIST_SEMANTIC_CAR_TRAILER]: ADS_LIST_SEMANTIC_CAR_TRAILER_REGEX,
  [ADS_LIST_SEMANTIC_CHEAP_VANS]: ADS_LIST_SEMANTIC_CHEAP_VANS_REGEX,
  [ADS_LIST_SEMANTIC_CLASSIC_COMPETITION]: ADS_LIST_SEMANTIC_CLASSIC_COMPETITION_REGEX,
  [ADS_LIST_SEMANTIC_TRUCKS]: ADS_LIST_SEMANTIC_TRUCKS_REGEX,
  [ADS_LIST_SEMANTIC_BUSES]: ADS_LIST_SEMANTIC_BUSES_REGEX,
  [ADS_LIST_SEMANTIC_FINANCED]: ADS_LIST_SEMANTIC_FINANCED_REGEX,
  [ADS_LIST_SEMANTIC_COLOR]: ADS_LIST_SEMANTIC_COLOR_REGEX,
  [ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE]: ADS_LIST_SEMANTIC_CARS_WITHOUT_LICENSE_REGEX,
  [ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL]: ADS_LIST_SEMANTIC_ENVIRONMENTAL_LABEL_REGEX,
  [ADS_LIST_SEMANTIC_LIFESTYLE]: ADS_LIST_SEMANTIC_LIFESTYLE_REGEX
}

/**
 * Offer types 3, 4 and 5 goes under '/km-0/' url
 */
export const ADS_LIST_PATH_PATTERNS = {
  [SEGUNDA_MANO_CATEGORY1_ID]: [
    SECOND_HAND_PATH_PATTERN,
    NEW_KM0_PATH_PATTERN,
    KM0_PATH_PATTERN,
    KM0_PATH_PATTERN,
    KM0_PATH_PATTERN,
    KM0_PATH_PATTERN
  ],
  [VANS_AND_COMMERCIAL_CATEGORY1_ID]: ['/vehiculos-industriales/'],
  [CLASSIC_AND_COMPETITION_CATEGORY1_ID]: ['/clasicos-competicion/'],
  [AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID]: ['/autocaravanas-y-remolques/'],
  [CARS_WITHOUT_LICENSE_CATEGORY1_ID]: ['/sin-carnet/']
}

export const ADS_LIST_FLATTENED_PATH_PATTERNS = [
  ...Object.values(ADS_LIST_PATH_PATTERNS).flat(Infinity),
  ADS_LIST_SUBSCRIPTION_PATH_PATTERN,
  ADS_LIST_SEARCH_PATH_PATTERN
]

export const ADS_LIST_PATH_PATTERNS_WITH_ALERTS_AVAILABLE = [
  ...ADS_LIST_PATH_PATTERNS[SEGUNDA_MANO_CATEGORY1_ID],
  ...ADS_LIST_PATH_PATTERNS[CARS_WITHOUT_LICENSE_CATEGORY1_ID]
]

// This will change next spritn. We'll use the regex.
export const ADS_DETAIL_PATH_PATTERN = '/detail/:id/'
export const ADS_DETAIL_REGEX_PATH_PATTERN = /\/.*-(?<adId>\d{4,9})-[a-z]{2,4}(vo|vn)\.aspx(\?.*)?$/
export const ADS_DETAIL_SUBSCRIPTION_REGEX_PATH_PATTERN = /\/renting\/.*-(?<adId>\d{4,9})-vsre(\?.*)?$/
export const ADS_DETAIL_PREVIEW_PATH_PATTERN = '/preview/:id'

export const PROFESSIONAL_STOCK_PATH = '/concesionario'
export const PROFESSIONAL_STOCK_PATH_PATTERN = `${PROFESSIONAL_STOCK_PATH}/:dealer/:section?/`
export const PROFESSIONAL_STOCK_RENTING_PATH_PATTERN = `${ADS_LIST_SUBSCRIPTION_PATH_PATTERN}concesionario/:dealer/:section?/`
export const PROFESSIONAL_STOCK_RENTING_WITH_REGEX =
  /^\/renting\/concesionario\/(?<dealerSlug>[A-Za-z0-9\-&]*)(\/(opiniones|informacion))?\/?$/

export const PROFESSIONAL_STOCK_WITH_ID_REGEX =
  /^\/concesionario\/(?<contractId>[A-Za-z0-9\-&]*)(\/(opiniones|informacion))?\/?$/

export const DEALERS_LIST_PATH = '/concesionarios/'
export const DEALERS_LIST_PATH_PATTERN = `${DEALERS_LIST_PATH}*`

export const INSURANCE_PATH = '/seguros'

export const NEWS_CATEGORY_PATH_PATTERN = '/noticias/:category/'
export const NEWS_CATEGORY_REGEX_PATH_PATTERN =
  /(\/noticias(\/)*$)|(?<category>(\/noticias\/((?=novedades|videos|pruebas|comparativas|[\\?&]([^&=]+)=([^&=]+)).+)))/
export const NEWS_HOME_PATH_PATTERN = '/noticias/'
export const NEWS_SEARCH_PATH_PATTERN = `/noticias/${QUESTION_MARK}${QUERY_SEARCH_PATTERN}:tag`
export const NEWS_SEARCH_QUERY = `/noticias/${QUESTION_MARK}${QUERY_SEARCH_PATTERN}`
export const NEWS_SECTION_TIPS_PATH_PATTERN = '/consejos/'
export const NEWS_SECTION_TRENDS_PATH_PATTERN = '/tendencias/'
export const NEWS_TAG_PATH_PATTERN = `/noticias/t/:tag/`
export const NEWS_TAG_REGEX_PATH_PATTERN = /\/noticias\/t\/(?<tag>[^/]+)\/?/
export const NEWS_DETAIL_REGEX_PATH_PATTERN =
  /(\/noticias\/(?<slug1>((?!((novedades|videos|pruebas|comparativas|t)\/|[\\?&]([^&=]+)=([^&=]+))).+))|(\/(videos|tendencias|comparativas|consejos)\/(?<slug2>.+)))|(\/preview-news-detail\/.+)/
export const NEWS_COMMENTS_BASE_PATH = '/opiniones'
export const NEWS_COMMENTS_PATH_PATTERN = `${NEWS_COMMENTS_BASE_PATH}/:category/:slug/:optional1?/:optional2?/:optional3?/:optional4?`
export const LANDING_FINANCING_PATH_PATTERN = '/financiacion/'
export const LANDING_FORMALITIES_PATH_PATTERN = '/tramites-compra-venta-coches/'
export const LANDING_FORMALITIES_SECURITY_GUIDELINES_PATH_PATTERN = '/guia-seguridad-compra-venta-coches/'

export const COMPARATOR_PATH_PATTERN = '/comparador/'

export const NET_PATH_PATTERN = '/assistant'

export const RECOMMENDATIONS_PATH_PATTERN = '/recommendations/'

export const BASKET_PAGE_PATTERN = 'poner_anuncio/vender_mi_coche_cesta.aspx?IdE=:encryptedAdId'
export const LIMIT_EXCEEDED_PAGE_PATTERN = 'poner_anuncio/segundo-anuncio.aspx?c=:resultCode&IdE=:encryptedAdId'
export const USER_JOKER_PAGE_PATTERN = 'poner_anuncio/sinpermisos.aspx'
export const NOT_PUBLISHED_PAGE_PATTERN = 'poner_anuncio/sinpermisos.aspx'

export const USER_DISCOUNTS_PATH_PATTERN = '/user/discounts/'
export const USER_PHONE_VERIFICATION_PATTERN = '/user/phone/verification/'
export const USER_PROFILE_PATTERN = '/user/profile/'
export const USER_PROFILE_EDIT_PATTERN = '/user/profile/edit/'
export const USER_FAVORITE_ADS_PATH_PATTERN = '/user/favorites'
export const USER_FAVORITE_DEALERS_PATH_PATTERN = '/user/favorites/dealers'
export const USER_SAVED_SEARCHES_PATH_PATTERN = '/user/alerts/'
export const USER_ALERTS_MATCHES_PATH_PATTERN = '/user/alerts/:alertId/'
export const USER_UNSUBSCRIBE_SAVED_SEARCHES_PATH_PATTERN = '/coches/alerts/unsubscribe/'
export const USER_MESSAGES_PATH_PATTERN = '/user/messages/'

export const USER_ADS_PATH_PATTERN = '/mis-anuncios'
export const USER_UNSUBSCRIBES_EMAILS_PATH_PATTERN = '/cancelar-suscripcion-emails'

export const USER_ACCOUNT_TAKE_OUT_PATTERN = '/user/takeout'
export const CHECKOUT_PATH_PATTERN = '/checkout/'
export const CHECKOUT_URL = `${CHECKOUT_PATH_PATTERN}?adId=:adId&products=:products`
export const CHECKOUT_SUCCESS_PATH_PATTERN = '/checkout/success'
export const CHECKOUT_ERROR_PATH_PATTERN = '/checkout/error'
export const CHECKOUT_PENDING_PATH_PATTERN = '/checkout/pending'
export const CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN = '/checkout/activation-error'
export const CHECKOUT_REFUND_ERROR_PATH_PATTERN = '/checkout/refund-error'
export const CHECKOUT_REQUEST_ERROR_PATH_PATTERN = '/checkout/request-error'
export const CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN = '/checkout/unknown-error'
export const PAYMENT_AD_REQUEST_PATH_PATTERN = '/payment-ad'

export const MOBILE_PAGES_PATH_PATTERN = '/mobile'

export const TECHNICAL_DETAILS_PATH_PATTERN = '/fichas_tecnicas/'
export const TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}comparador/`
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_PATH_PATTERN = `${TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN}:vehicle1Id/:vehicle2Id?/`
export const TECHNICAL_DETAILS_SEARCH_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}buscador/`
export const TECHNICAL_DETAILS_SEARCH_RESULTS_PATH_PATTERN = `${TECHNICAL_DETAILS_SEARCH_PATH_PATTERN}${QUESTION_MARK}${WILDCARD_MARK}`
export const TECHNICAL_DETAILS_MAKE_PATH_PATTERN = `${TECHNICAL_DETAILS_PATH_PATTERN}:make/`
export const TECHNICAL_DETAILS_MODEL_PATH_PATTERN = `${TECHNICAL_DETAILS_MAKE_PATH_PATTERN}:model/`
export const TECHNICAL_DETAILS_BODY_TYPE_PATH_PATTERN = `${TECHNICAL_DETAILS_MODEL_PATH_PATTERN}:bodyType/:doors/`
export const TECHNICAL_DETAILS_VERSION_PATH_PATTERN = `${TECHNICAL_DETAILS_BODY_TYPE_PATH_PATTERN}:version/:versionId/`
export const TECHNICAL_DETAILS_VEHICLE_PATH_PATTERN = `${TECHNICAL_DETAILS_VERSION_PATH_PATTERN}:vehicleId/`
export const TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PATH_PATTERN = `${TECHNICAL_DETAILS_BODY_TYPE_PATH_PATTERN}:vehicleId/`
export const TECHNICAL_DETAILS_BODY_TYPE_PATH_REGEX = /(?<bodyType>[a-z_4]+)-(?<doors>[0-9]{1})-(?<year>[0-9]{4})/

export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PATH_PATTERN = '/transaction/buyer/id-upload-back'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PATH_PATTERN = '/transaction/buyer/id-upload-front'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PATH_PATTERN = '/transaction/buyer/identity'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START_PATH_PATTERN = '/transaction/buyer/id'

export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT_PATH_PATTERN = '/transaction/seller/account'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PATH_PATTERN = '/transaction/seller/id-upload-back'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PATH_PATTERN = '/transaction/seller/id-upload-front'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PATH_PATTERN = '/transaction/seller/identity'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START_PATH_PATTERN = '/transaction/seller/id'

export const ADS_LIST_MAKE_MODEL_KM0_PATH_PATTERN = '/:make/:model/km-0/'
export const ADS_LIST_MAKE_MODEL_NEW_VEHICLE_PATH_PATTERN = '/:make/:model/nuevo/km-0/'
export const ADS_LIST_MAKE_MODEL_USED_PATH_PATTERN = '/:make/:model/segunda-mano/'

export const ADS_LIST_SUBSCRIPTION_MAKE_MODEL_RENTING_PATH_PATTERN = '/renting/:make/:model/'

export const WDYL_MAKE_MODEL_PATH_PATTERN = '/s/:make/:model'
export const MODEL_SIZES_PATH_PATTERN = '/s/medidas/:make/:model'
export const MODEL_SIZES_PATH_PATTERN_REGEX = /\/s\/medidas\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_PATH_PATTERN = '/s/'
export const MODEL_DETAIL_INTERIOR_PATH_PATTERN = '/s/interior/:make/:model/'
export const MODEL_DETAIL_TRUNK_PATH_PATTERN = '/s/maletero/:make/:model/'

export const VEHICLE_CONFIGURATOR_PATH = '/configurador/'
export const VEHICLE_SUGGESTER_PATH = '/ayudame-a-elegir/'
export const VEHICLE_SUGGESTER_BODY_TYPE_PATH = `${VEHICLE_SUGGESTER_PATH}tipo-de-carroceria/`
export const VEHICLE_SUGGESTER_FUEL_TYPE_PATH = `${VEHICLE_SUGGESTER_PATH}combustible/`
export const VEHICLE_CONFIGURATOR_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}{:make{/:model}}`
export const VEHICLE_SUGGESTER_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}`
export const VEHICLE_SUGGESTER_PATH_PATTERN_REGEX = /\/ayudame-a-elegir\/?/
export const VEHICLE_SUGGESTER_BODY_TYPE_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}tipo-de-carroceria/`
export const VEHICLE_SUGGESTER_FUEL_TYPE_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}combustible/`
export const VEHICLE_SUGGESTER_SEATS_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}plazas/`
export const VEHICLE_SUGGESTER_MAKES_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}marcas/`
export const VEHICLE_SUGGESTER_RESULTS_PATH_PATTERN = `${VEHICLE_SUGGESTER_PATH}resultados/`

export const VEHICLE_CONFIGURATOR_FUEL_TYPE_PATH = `${VEHICLE_CONFIGURATOR_PATH}combustible/`
export const VEHICLE_CONFIGURATOR_TRIM_LEVEL_PATH = `${VEHICLE_CONFIGURATOR_PATH}acabados/`
export const VEHICLE_CONFIGURATOR_ENGINE_PATH = `${VEHICLE_CONFIGURATOR_PATH}motor/`
export const VEHICLE_CONFIGURATOR_COLOR_PATH = `${VEHICLE_CONFIGURATOR_PATH}color/`
export const VEHICLE_CONFIGURATOR_FORM_PATH = `${VEHICLE_CONFIGURATOR_PATH}formulario/`
export const VEHICLE_CONFIGURATOR_RESULTS_PATH = `${VEHICLE_CONFIGURATOR_PATH}resultado/`
export const VEHICLE_CONFIGURATOR_MAKE_MODEL_PATH_PATTERN = VEHICLE_CONFIGURATOR_PATH_PATTERN
export const VEHICLE_CONFIGURATOR_FUEL_TYPE_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}combustible/`
export const VEHICLE_CONFIGURATOR_TRIM_LEVEL_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}acabados/`
export const VEHICLE_CONFIGURATOR_ENGINE_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}motor/`
export const VEHICLE_CONFIGURATOR_COLOR_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}color/`
export const VEHICLE_CONFIGURATOR_FORM_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}formulario/`
export const VEHICLE_CONFIGURATOR_RESULTS_PATH_PATTERN = `${VEHICLE_CONFIGURATOR_PATH}resultado/`
export const VEHICLE_CONFIGURATOR_PATH_PATTERN_REGEX = /\/configurador\/?/

export const MAKE_PATH_PATTERN = '/s/:make/'
export const MAKES_SIZES_DISTRIBUTOR_PATH_PATTERN = '/s/medidas/'
export const MODEL_DETAIL_PATH_PATTERN_REGEX = /\/s\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_INTERIOR_PATH_PATTERN_REGEX = /\/s\/interior\/([^/]+)\/([^/]+)\/?/
export const MODEL_DETAIL_TRUNK_PATH_PATTERN_REGEX = /\/s\/maletero\/([^/]+)\/([^/]+)\/?/
export const PRIVATE_WALLET_PATH_PATTERN = '/monedero-privado/'
export const SELLER_SECURE_PAYMENT_BENEFITS_PATH_PATTERN = '/beneficios-vendedor-pago-seguro/'

export const PROFESSIONALS_PATH_PATTERN = '/registro-profesionales'
export const MY_ADS_PATH_PATTERN = '/mis-anuncios'
export const PUBLISH_MY_AD_PATH_PATTERN = '/publicar-mi-anuncio'
export const PUBLISH_MY_AD_CATEGORY_PATH_PATTERN = '/publicar-mi-anuncio/categoria'
export const EDIT_MY_AD_PATH_PATTERN = '/editar-mi-anuncio'
export const EDIT_MY_AD_OTHER_CATEGORIES_PATH_PATTERN = '/GTA_new/editar-mi-anuncio.aspx'
export const PUBLISH_YOUR_VEHICLE_PATH_PATTERN = PTA_PATH_PATTERN
export const PUBLISH_YOUR_VEHICLE_PATH_PATTERNS = `${PTA_PATH_PATTERN}/:province`
export const PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PATTERN = '/vender-mi-coche-con-matricula'
export const PUBLISH_YOUR_VEHICLE_ERROR_PATH_PATTERN = '/poner_anuncio/anuncio-no-publicado.aspx'
export const LANDING_INSTANT_OFFER_PATTERN = '/vender-coche-a-un-concesionario'
// web_seller_instant_offer_landing_test
export const LANDING_INSTANT_OFFER_TEST_PATTERN = '/vender-coche-a-un-profesional'
export const INSTANT_OFFER_SELL_TO_DEALER_PATTERN = '/vende-a-concesionario'
export const INSTANT_OFFER_STANDALONE_PATTERN = '/vender-mi-coche-a-un-concesionario'
export const VEHICLE_APPRAISER_PATH_PATTERN = '/tasacion-de-coches/'
export const RATING_PATH_PATTERN = '/rating/:tradeId/'
export const RESERVATION_PATH_PATTERN = '/reservation'
export const RESERVATION_PAYMENT_PATH_PATTERN = '/reservation/payment'
export const RESERVATION_REFUND_PATH_PATTERN = '/reservation/refund'
export const RESERVATION_REFUND_REASON_PATH_PATTERN = '/reservation/refund/reason'
export const RESERVATION_B2C_USER_RETURNS_FROM_RAPIDPAY_PATH_PATTERN = '/reservation'
export const RESERVATION_C2B_USER_FORM_PATH_PATTERN = '/reserva/formulario/'
export const USER_PROFILE_COMPLETE_PURCHASE_PATTERN = '/user/profile/complete/purchase'
export const USER_PROFILE_COMPLETE_RESERVATION_PATTERN = '/user/profile/complete/reservation'
export const TRANSACTION_PATTERN = '/transaction'

export const CHECKOUT_PAGE_NAME = 'checkout'
export const CHECKOUT_SUCCESS_PAGE_NAME = 'checkout-success'
export const CHECKOUT_ERROR_PAGE_NAME = 'checkout-error'
export const CHECKOUT_PENDING_PAGE_NAME = 'checkout-pending'
export const CHECKOUT_ACTIVATION_ERROR_PAGE_NAME = 'checkout-activation-error'
export const CHECKOUT_REFUND_ERROR_PAGE_NAME = 'checkout-refund-error'
export const CHECKOUT_REQUEST_ERROR_PAGE_NAME = 'checkout-request-error'
export const CHECKOUT_UNKNOWN_ERROR_PAGE_NAME = 'checkout-unknown-error'

export const ADS_DETAIL_PAGE_NAME = 'ads-detail'
export const ADS_DETAIL_GALLERY_PAGE_NAME = 'ads-detail-gallery'
export const ADS_DETAIL_PREVIEW_PAGE_NAME = 'ads-detail-preview'
export const ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME = 'ads-list-autocaravans-and-trailers'
export const ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME = 'ads-list-cars-without-license'
export const ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME = 'ads-list-classic-and-competition'
export const ADS_LIST_FILTERS_PAGE_NAME = 'ads-list-filters'
export const ADS_LIST_PAGE_NAME = 'ads-list'
export const ADS_LIST_SUBSCRIPTION_PAGE_NAME = 'ads-list-subscription'
export const ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME = 'ads-list-business-subscription'
export const ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME = 'ads-list-vans-and-commercial'
export const DEALERS_LIST_PAGE_NAME = 'dealers-list'
export const HOME_PAGE_NAME = 'home'
export const INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME = 'instant-offer-sell-to-dealer'
export const INSTANT_OFFER_STANDALONE_PAGE_NAME = 'instant-offer-standalone'
export const INSURANCE_PAGE_NAME = 'insurance'
export const LANDING_FINANCING_PAGE_NAME = 'landing-financing'
export const LANDING_FORMALITIES_PAGE_NAME = 'landing-formalities'
export const LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME = 'landing-formalities-security-guidelines'
export const LANDING_INSTANT_OFFER_PAGE_NAME = 'landing-instant-offer'
// web_seller_instant_offer_landing_test
export const LANDING_INSTANT_OFFER_TEST_PAGE_NAME = 'landing-instant-offer-test'
export const LOGIN_PAGE_NAME = 'login'
export const MAKE_PAGE_NAME = 'make'
export const MAKES_DISTRIBUTOR_PAGE_NAME = 'makes-distributor'
export const MAKES_SIZES_DISTRIBUTOR_PAGE_NAME = 'makes-sizes-distributor'
export const MODEL_DETAIL_PAGE_NAME = 'model-detail'
export const MODEL_DETAIL_INTERIOR_PAGE_NAME = 'model-detail-interior'
export const MODEL_DETAIL_TRUNK_PAGE_NAME = 'model-detail-trunk'
export const MODEL_SIZES_PAGE_NAME = 'model-sizes'
export const NEWS_CATEGORY_PAGE_NAME = 'news-category'
export const NEWS_COMMENTS_PAGE_NAME = 'news-comments'
export const NEWS_DETAIL_PAGE_NAME = 'news-detail'
export const NEWS_SEARCH_PAGE_NAME = 'news-search'
export const NEWS_SECTION_TIPS_PAGE_NAME = 'news-section-tips'
export const NEWS_SECTION_TRENDS_PAGE_NAME = 'news-section-trends'
export const NEWS_TAG_PAGE_NAME = 'news-tag'
export const OTHER_PARTNERS_PAGE_NAME = 'other-partners'
export const PAYMENT_AD_REQUEST_PAGE_NAME = 'payment-ad-request'
export const PRODUCTS_PAGE_NAME = 'products'
export const PROFESSIONAL_STOCK_PAGE_NAME = 'professional-stock'
export const PROFESSIONAL_STOCK_RENTING_PAGE_NAME = 'professional-stock-renting'
export const PROFESSIONALS_PAGE_NAME = 'professionals'
export const PTA_PAGE_NAME = 'pta'
export const MY_ADS_PAGE_NAME = 'ad-management-my-ads'
export const PUBLISH_MY_AD_PAGE_NAME = 'publish-my-ad'
export const PUBLISH_MY_AD_CATEGORY_PAGE_NAME = 'publish-my-ad-category'
export const EDIT_MY_AD_PAGE_NAME = 'edit-my-ad'
export const PUBLISH_YOUR_VEHICLE_PAGE_NAME = 'publish-your-vehicle'
export const PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PAGE_NAME = 'publish-your-vehicle-with-plate'
export const PUBLISH_YOUR_VEHICLE_WITH_PLATE_RESULTS_PAGE_NAME = 'publish-your-vehicle-with-plate-results'
export const RATING_PAGE_NAME = 'rating'
export const COMPARADOR_PAGE_NAME = 'comparador'
export const NET_PAGE_NAME = 'net_assistant'
export const RECOMMENDATIONS_PAGE_NAME = 'recommendations'
export const RESERVATION_USER_RETURNS_FROM_RAPIDPAY_PAGE_NAME = 'reservation'
export const RESERVATION_C2B_USER_FORM_PAGE_NAME = 'reservation-user-form'
export const TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME = 'technical-details-body-type'
export const TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME = 'technical-details-comparator'
export const TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME = 'technical-details-comparator-results'
export const TECHNICAL_DETAILS_HOME_PAGE_NAME = 'technical-details'
export const TECHNICAL_DETAILS_MAKE_PAGE_NAME = 'technical-details-make'
export const TECHNICAL_DETAILS_MODEL_PAGE_NAME = 'technical-details-model'
export const TECHNICAL_DETAILS_SEARCH_PAGE_NAME = 'technical-details-search'
export const TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME = 'technical-details-search-results'
export const TECHNICAL_DETAILS_VEHICLE_PAGE_NAME = 'technical-details-vehicle'
export const TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME = 'technical-details-vehicle-without-version'
export const TECHNICAL_DETAILS_VERSION_PAGE_NAME = 'technical-details-version'
export const TERMS_OF_SERVICE_PAGE_NAME = 'terms-of-service'
export const TRANSPARENCY_PAGE_NAME = 'transparency'
export const TERMS_OF_SERVICE_RESERVATION_PAGE_NAME = 'terms-of-service-reservation'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-dni-back'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-dni-front'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DOCUMENTS_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-documents'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-personal-data'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-start'
export const TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME =
  'transaction-buyer-identity-validation-flow-success'
export const TRANSACTION_BUYER_LEGAL_CONDITIONS_START_PAGE_NAME = 'transaction-buyer-legal-conditions-start'
export const TRANSACTION_BUYER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME = 'transaction-buyer-legal-conditions-success'
export const TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_ERROR_PAGE_NAME =
  'transaction-buyer-paycar-rapidpay-purchase-error'
export const TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_START_PAGE_NAME =
  'transaction-buyer-paycar-rapidpay-purchase-start'
export const TRANSACTION_BUYER_PAYCAR_RAPIDPAY_PURCHASE_SUCCESS_PAGE_NAME =
  'transaction-buyer-paycar-rapidpay-purchase-success'
export const TRANSACTION_BUYER_PRICE_NEGOTIATION_START_PAGE_NAME = 'transaction-buyer-price-negotiation-start'
export const TRANSACTION_BUYER_PRICE_NEGOTIATION_SUCCESS_PAGE_NAME = 'transaction-buyer-price-negotiation-success'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT_PAGE_NAME =
  'transaction-seller-identity-validation-flow-bank-account'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME =
  'transaction-seller-identity-validation-flow-dni-back'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME =
  'transaction-seller-identity-validation-flow-dni-front'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DOCUMENTS_PAGE_NAME =
  'transaction-seller-identity-validation-flow-documents'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME =
  'transaction-seller-identity-validation-flow-personal-data'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME =
  'transaction-seller-identity-validation-flow-start'
export const TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_SUCCESS_PAGE_NAME =
  'transaction-seller-identity-validation-flow-success'
export const TRANSACTION_SELLER_LEGAL_CONDITIONS_START_PAGE_NAME = 'transaction-seller-legal-conditions-start'
export const TRANSACTION_SELLER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME = 'transaction-seller-legal-conditions-success'
export const TRANSACTION_SELLER_PRICE_NEGOTIATION_START_PAGE_NAME = 'transaction-seller-price-negotiation-start'
export const TRANSACTION_SELLER_PRICE_NEGOTIATION_SUCCESS_PAGE_NAME = 'transaction-seller-price-negotiation-success'
export const USER_ACCOUNT_TAKE_OUT_PAGE_NAME = 'user-account-take-out'
export const USER_DISCOUNTS_PAGE_NAME = 'user-discounts'
export const USER_FAVORITE_ADS_PAGE_NAME = 'user-favorite-ads'
export const USER_FAVORITE_DEALERS_PAGE_NAME = 'user-favorite-dealers'
export const USER_MESSAGES_PAGE_NAME = 'user-messaging'
export const USER_PHONE_VERIFICATION_PAGE_NAME = 'user-phone-verification'
export const USER_PROFILE_PAGE_NAME = 'user-profile'
export const USER_PROFILE_COMPLETE_PURCHASE_BUYER_PAGE_NAME = 'user-profile-complete-purchase-buyer'
export const USER_PROFILE_EDIT_PAGE_NAME = 'user-profile-edit'
export const USER_SAVED_SEARCHES_PAGE_NAME = 'user-saved-searches'
export const USER_ALERTS_MATCHES_PAGE_NAME = 'user-alerts-matches'
export const USER_UNSUBSCRIBE_SAVED_SEARCHES_PAGE_NAME = 'user-unsubscribe-saved-searches'
export const VEHICLE_APPRAISER_PAGE_NAME = 'vehicle-appraiser'
export const VEHICLE_SUGGESTER_PAGE_NAME = 'vehicle-suggester'
export const VEHICLE_SUGGESTER_PRICE_RANGE_PAGE_NAME = 'vehicle-suggester-price-range'
export const VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME = 'vehicle-suggester-body-type'
export const VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME = 'vehicle-suggester-fuel-type'
export const VEHICLE_SUGGESTER_SEATS_PAGE_NAME = 'vehicle-suggester-seats'
export const VEHICLE_SUGGESTER_MAKES_PAGE_NAME = 'vehicle-suggester-makes'
export const VEHICLE_SUGGESTER_RESULTS_PAGE_NAME = 'vehicle-suggester-results'
export const VEHICLE_SUGGESTER_DETAILS_PAGE_NAME = 'vehicle-suggester-details'

export const VEHICLE_CONFIGURATOR_PAGE_NAME = 'vehicle-configurator'
export const VEHICLE_CONFIGURATOR_FUEL_TYPE_PAGE_NAME = 'vehicle-configurator-fuel-type'
export const VEHICLE_CONFIGURATOR_TRIM_LEVEL_PAGE_NAME = 'vehicle-configurator-trim-level'
export const VEHICLE_CONFIGURATOR_ENGINE_PAGE_NAME = 'vehicle-configurator-engine'
export const VEHICLE_CONFIGURATOR_COLOR_PAGE_NAME = 'vehicle-configurator-color'
export const VEHICLE_CONFIGURATOR_FORM_PAGE_NAME = 'vehicle-configurator-form'
export const VEHICLE_CONFIGURATOR_RESULTS_PAGE_NAME = 'vehicle-configurator-results'
export const VEHICLE_CONFIGURATOR_ERROR_GENERIC_PAGE_NAME = 'vehicle-configurator-error-generic'
export const VEHICLE_CONFIGURATOR_ERROR_CONTENT_PAGE_NAME = 'vehicle-configurator-error-content'

export const VEHICLES_GRID_PAGE_NAME = 'vehicles-grid'

export const VEHICLE_CONFIGURATOR_PAGE_NAMES = {
  MAKE_MODEL: 'vehicle-configurator-make-model',
  FUEL_TYPE: 'vehicle-configurator-fuel-type',
  TRIM_LEVEL: 'vehicle-configurator-trim-level',
  ENGINE: 'vehicle-configurator-engine',
  COLOR: 'vehicle-configurator-color',
  ZIP_CODE: 'vehicle-configurator-zipcode',
  SUCCESS: 'vehicle-configurator-success',
  ERROR_GENERIC: 'vehicle-configurator-error-generic',
  ERROR_CONNECTION: 'vehicle-configurator-error-connection',
  ERROR_CONTACT: 'vehicle-configurator-error-contact',
  ERROR_CONTENT: 'vehicle-configurator-error-content'
}

export const STEPS_VEHICLE_CONFIGURATOR_PAGE_NAMES = {
  1: VEHICLE_CONFIGURATOR_PAGE_NAMES.MAKE_MODEL,
  2: VEHICLE_CONFIGURATOR_PAGE_NAMES.FUEL_TYPE,
  3: VEHICLE_CONFIGURATOR_PAGE_NAMES.TRIM_LEVEL,
  4: VEHICLE_CONFIGURATOR_PAGE_NAMES.ENGINE,
  5: VEHICLE_CONFIGURATOR_PAGE_NAMES.COLOR,
  6: VEHICLE_CONFIGURATOR_PAGE_NAMES.ZIP_CODE,
  7: VEHICLE_CONFIGURATOR_PAGE_NAMES.SUCCESS
}

export const DEALER_RATING_STEP_PAGE_NAMES = {
  0: 'DEALER_RATING_STEP_0',
  1: 'DEALER_RATING_STEP_1',
  2: 'DEALER_RATING_STEP_2',
  3: 'DEALER_RATING_STEP_3'
}

export const DEALER_RATING_STATE_PAGE_NAMES = {
  CLOSED: 'DEALER_RATING_STATE_CLOSED',
  EXPIRED: 'DEALER_RATING_STATE_EXPIRED',
  SUCCESS: 'DEALER_RATING_STATE_SUCCESS'
}

export const ADS_LIST_PAGE_NAMES = [
  ADS_LIST_PAGE_NAME,
  ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME,
  ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
  ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME
]

export const DISTRIBUTOR_PAGE_CONFIG = {
  [MAKES_DISTRIBUTOR_PAGE_NAME]: {
    literalPrefix: 'MAKES_DISTRIBUTOR',
    nextPagePattern: MODEL_DETAIL_PATH_PATTERN
  },
  [MAKES_SIZES_DISTRIBUTOR_PAGE_NAME]: {
    literalPrefix: 'MAKES_SIZES_DISTRIBUTOR',
    nextPagePattern: MAKES_SIZES_DISTRIBUTOR_PATH_PATTERN
  }
}

export const PAGE_PATTERNS = {
  [ADS_LIST_PAGE_NAME]: [...ADS_LIST_PATH_PATTERNS[SEGUNDA_MANO_CATEGORY1_ID]],
  [ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME]: ADS_LIST_PATH_PATTERNS[VANS_AND_COMMERCIAL_CATEGORY1_ID],
  [ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME]: ADS_LIST_PATH_PATTERNS[CLASSIC_AND_COMPETITION_CATEGORY1_ID],
  [ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME]: ADS_LIST_PATH_PATTERNS[AUTOCARAVANS_AND_TRAILERS_CATEGORY1_ID],
  [ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME]: ADS_LIST_PATH_PATTERNS[CARS_WITHOUT_LICENSE_CATEGORY1_ID],
  [ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME]: [ADS_LIST_BUSINESS_SUBSCRIPTION_PATH_PATTERN],
  [ADS_LIST_SUBSCRIPTION_PAGE_NAME]: [ADS_LIST_SUBSCRIPTION_PATH_PATTERN],
  [ADS_DETAIL_PAGE_NAME]: [
    ADS_DETAIL_PATH_PATTERN,
    ADS_DETAIL_REGEX_PATH_PATTERN,
    ADS_DETAIL_SUBSCRIPTION_REGEX_PATH_PATTERN
  ],
  [ADS_DETAIL_PREVIEW_PAGE_NAME]: [ADS_DETAIL_PREVIEW_PATH_PATTERN],
  [PROFESSIONAL_STOCK_PAGE_NAME]: [PROFESSIONAL_STOCK_PATH_PATTERN],
  [PROFESSIONAL_STOCK_RENTING_PAGE_NAME]: [PROFESSIONAL_STOCK_RENTING_PATH_PATTERN],
  [DEALERS_LIST_PAGE_NAME]: [DEALERS_LIST_PATH_PATTERN],
  [HOME_PAGE_NAME]: [HOME_PATH_PATTERN, AB_HOME_PATH_PATTERN],
  [INSURANCE_PAGE_NAME]: [INSURANCE_PATH],
  [MODEL_DETAIL_PAGE_NAME]: [WDYL_MAKE_MODEL_PATH_PATTERN],
  [MODEL_DETAIL_INTERIOR_PAGE_NAME]: [MODEL_DETAIL_INTERIOR_PATH_PATTERN, MODEL_DETAIL_INTERIOR_PATH_PATTERN_REGEX],
  [MODEL_DETAIL_TRUNK_PAGE_NAME]: [MODEL_DETAIL_TRUNK_PATH_PATTERN, MODEL_DETAIL_TRUNK_PATH_PATTERN_REGEX],
  [MODEL_SIZES_PAGE_NAME]: [MODEL_SIZES_PATH_PATTERN],
  [MAKES_DISTRIBUTOR_PAGE_NAME]: [MODEL_DETAIL_PATH_PATTERN],
  [VEHICLE_SUGGESTER_PAGE_NAME]: [VEHICLE_SUGGESTER_PATH_PATTERN],
  [VEHICLE_SUGGESTER_PRICE_RANGE_PAGE_NAME]: [VEHICLE_SUGGESTER_PATH_PATTERN],
  [VEHICLE_SUGGESTER_BODY_TYPE_PAGE_NAME]: [VEHICLE_SUGGESTER_BODY_TYPE_PATH_PATTERN],
  [VEHICLE_SUGGESTER_FUEL_TYPE_PAGE_NAME]: [VEHICLE_SUGGESTER_FUEL_TYPE_PATH_PATTERN],
  [VEHICLE_SUGGESTER_SEATS_PAGE_NAME]: [VEHICLE_SUGGESTER_SEATS_PATH_PATTERN],
  [VEHICLE_SUGGESTER_MAKES_PAGE_NAME]: [VEHICLE_SUGGESTER_MAKES_PATH_PATTERN],
  [VEHICLE_SUGGESTER_RESULTS_PAGE_NAME]: [VEHICLE_SUGGESTER_RESULTS_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_FUEL_TYPE_PAGE_NAME]: [VEHICLE_CONFIGURATOR_FUEL_TYPE_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_TRIM_LEVEL_PAGE_NAME]: [VEHICLE_CONFIGURATOR_TRIM_LEVEL_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_ENGINE_PAGE_NAME]: [VEHICLE_CONFIGURATOR_ENGINE_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_COLOR_PAGE_NAME]: [VEHICLE_CONFIGURATOR_COLOR_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_FORM_PAGE_NAME]: [VEHICLE_CONFIGURATOR_FORM_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_RESULTS_PAGE_NAME]: [VEHICLE_CONFIGURATOR_RESULTS_PATH_PATTERN],
  [VEHICLE_CONFIGURATOR_PAGE_NAME]: [VEHICLE_CONFIGURATOR_PATH_PATTERN, VEHICLE_CONFIGURATOR_PATH_PATTERN_REGEX],
  [MAKES_SIZES_DISTRIBUTOR_PAGE_NAME]: [MAKES_SIZES_DISTRIBUTOR_PATH_PATTERN],
  [NEWS_SEARCH_PAGE_NAME]: [NEWS_SEARCH_PATH_PATTERN],
  [NEWS_TAG_PAGE_NAME]: [NEWS_TAG_PATH_PATTERN, NEWS_TAG_REGEX_PATH_PATTERN],
  // Note: details paths need to be defined before categories to avoid matching "/noticias/videos-de-coches-caros" as news category listings because of "/noticias/videos" rule
  [NEWS_COMMENTS_PAGE_NAME]: [NEWS_COMMENTS_PATH_PATTERN],
  [NEWS_DETAIL_PAGE_NAME]: [NEWS_DETAIL_REGEX_PATH_PATTERN],
  [NEWS_CATEGORY_PAGE_NAME]: [NEWS_CATEGORY_REGEX_PATH_PATTERN],
  [NEWS_SECTION_TIPS_PAGE_NAME]: [NEWS_SECTION_TIPS_PATH_PATTERN],
  [NEWS_SECTION_TRENDS_PAGE_NAME]: [NEWS_SECTION_TRENDS_PATH_PATTERN],
  [LANDING_FINANCING_PAGE_NAME]: [LANDING_FINANCING_PATH_PATTERN],
  [LANDING_FORMALITIES_PAGE_NAME]: [LANDING_FORMALITIES_PATH_PATTERN],
  [LANDING_FORMALITIES_SECURITY_GUIDELINES_PAGE_NAME]: [LANDING_FORMALITIES_SECURITY_GUIDELINES_PATH_PATTERN],
  [LOGIN_PAGE_NAME]: [LOGIN_PATH_PATTERN, AB_LOGIN_PATH_PATTERN],
  [TERMS_OF_SERVICE_PAGE_NAME]: [TERMS_OF_SERVICE_PATH_PATTERN],
  [TRANSPARENCY_PAGE_NAME]: [TRANSPARENCY_PATH_PATTERN],
  [TERMS_OF_SERVICE_RESERVATION_PAGE_NAME]: [TERMS_OF_SERVICE_RESERVATION_PATH_PATTERN],
  [OTHER_PARTNERS_PAGE_NAME]: [OTHER_PARTNERS_PATH_PATTERN],
  [PTA_PAGE_NAME]: [PTA_PATH_PATTERN],
  [COMPARADOR_PAGE_NAME]: [COMPARATOR_PATH_PATTERN],
  [NET_PAGE_NAME]: [NET_PATH_PATTERN],
  [RECOMMENDATIONS_PAGE_NAME]: [RECOMMENDATIONS_PATH_PATTERN],
  [USER_SAVED_SEARCHES_PAGE_NAME]: [USER_SAVED_SEARCHES_PATH_PATTERN],
  [USER_ALERTS_MATCHES_PAGE_NAME]: [USER_ALERTS_MATCHES_PATH_PATTERN],
  [USER_DISCOUNTS_PAGE_NAME]: [USER_DISCOUNTS_PATH_PATTERN],
  [USER_UNSUBSCRIBE_SAVED_SEARCHES_PAGE_NAME]: [USER_UNSUBSCRIBE_SAVED_SEARCHES_PATH_PATTERN],
  [USER_FAVORITE_ADS_PAGE_NAME]: [USER_FAVORITE_ADS_PATH_PATTERN],
  [USER_FAVORITE_DEALERS_PAGE_NAME]: [USER_FAVORITE_DEALERS_PATH_PATTERN],
  [USER_MESSAGES_PAGE_NAME]: [USER_MESSAGES_PATH_PATTERN],
  [USER_PHONE_VERIFICATION_PAGE_NAME]: [USER_PHONE_VERIFICATION_PATTERN],
  [USER_PROFILE_PAGE_NAME]: [USER_PROFILE_PATTERN],
  [USER_PROFILE_EDIT_PAGE_NAME]: [USER_PROFILE_EDIT_PATTERN],
  [USER_ACCOUNT_TAKE_OUT_PAGE_NAME]: [USER_ACCOUNT_TAKE_OUT_PATTERN],
  [CHECKOUT_PAGE_NAME]: [CHECKOUT_PATH_PATTERN],
  [CHECKOUT_SUCCESS_PAGE_NAME]: [CHECKOUT_SUCCESS_PATH_PATTERN],
  [CHECKOUT_ERROR_PAGE_NAME]: [CHECKOUT_ERROR_PATH_PATTERN],
  [CHECKOUT_PENDING_PAGE_NAME]: [CHECKOUT_PENDING_PATH_PATTERN],
  [CHECKOUT_ACTIVATION_ERROR_PAGE_NAME]: [CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN],
  [CHECKOUT_REFUND_ERROR_PAGE_NAME]: [CHECKOUT_REFUND_ERROR_PATH_PATTERN],
  [CHECKOUT_REQUEST_ERROR_PAGE_NAME]: [CHECKOUT_REQUEST_ERROR_PATH_PATTERN],
  [CHECKOUT_UNKNOWN_ERROR_PAGE_NAME]: [CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN],
  [PRODUCTS_PAGE_NAME]: [PRODUCTS_PATH_PATTERN],
  [PAYMENT_AD_REQUEST_PAGE_NAME]: [PAYMENT_AD_REQUEST_PATH_PATTERN],
  [MY_ADS_PAGE_NAME]: [MY_ADS_PATH_PATTERN],
  [PUBLISH_MY_AD_PAGE_NAME]: [PUBLISH_MY_AD_PATH_PATTERN],
  [PUBLISH_MY_AD_CATEGORY_PAGE_NAME]: [PUBLISH_MY_AD_CATEGORY_PATH_PATTERN],
  [EDIT_MY_AD_PAGE_NAME]: [EDIT_MY_AD_PATH_PATTERN],
  [PUBLISH_YOUR_VEHICLE_PAGE_NAME]: [PUBLISH_YOUR_VEHICLE_PATH_PATTERN],
  [PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PAGE_NAME]: [PUBLISH_YOUR_VEHICLE_PATH_WITH_PLATE_PATTERN],
  [RATING_PAGE_NAME]: [RATING_PATH_PATTERN],
  [TECHNICAL_DETAILS_HOME_PAGE_NAME]: [TECHNICAL_DETAILS_PATH_PATTERN],
  [TECHNICAL_DETAILS_COMPARATOR_PAGE_NAME]: [TECHNICAL_DETAILS_COMPARATOR_PATH_PATTERN],
  [TECHNICAL_DETAILS_COMPARATOR_RESULTS_PAGE_NAME]: [TECHNICAL_DETAILS_COMPARATOR_RESULTS_PATH_PATTERN],
  [TECHNICAL_DETAILS_SEARCH_PAGE_NAME]: [TECHNICAL_DETAILS_SEARCH_PATH_PATTERN],
  [TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME]: [TECHNICAL_DETAILS_SEARCH_RESULTS_PATH_PATTERN],
  [TECHNICAL_DETAILS_MAKE_PAGE_NAME]: [TECHNICAL_DETAILS_MAKE_PATH_PATTERN],
  [TECHNICAL_DETAILS_MODEL_PAGE_NAME]: [TECHNICAL_DETAILS_MODEL_PATH_PATTERN],
  [TECHNICAL_DETAILS_BODY_TYPE_PAGE_NAME]: [TECHNICAL_DETAILS_BODY_TYPE_PATH_PATTERN],
  [PROFESSIONALS_PAGE_NAME]: [PROFESSIONALS_PATH_PATTERN],
  [TECHNICAL_DETAILS_VERSION_PAGE_NAME]: [TECHNICAL_DETAILS_VERSION_PATH_PATTERN],
  [TECHNICAL_DETAILS_VEHICLE_PAGE_NAME]: [TECHNICAL_DETAILS_VEHICLE_PATH_PATTERN],
  [TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PAGE_NAME]: [TECHNICAL_DETAILS_VEHICLE_WITHOUT_VERSION_PATH_PATTERN],
  [TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME]: [
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PATH_PATTERN
  ],
  [TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME]: [
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PATH_PATTERN
  ],
  [TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME]: [
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PATH_PATTERN
  ],
  [TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME]: [
    TRANSACTION_BUYER_IDENTITY_VALIDATION_FLOW_START_PATH_PATTERN
  ],
  [TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT_PAGE_NAME]: [
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_BANK_ACCOUNT_PATH_PATTERN
  ],
  [TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PAGE_NAME]: [
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_BACK_PATH_PATTERN
  ],
  [TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PAGE_NAME]: [
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_DNI_FRONT_PATH_PATTERN
  ],
  [TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PAGE_NAME]: [
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_PERSONAL_DATA_PATH_PATTERN
  ],
  [TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START_PAGE_NAME]: [
    TRANSACTION_SELLER_IDENTITY_VALIDATION_FLOW_START_PATH_PATTERN
  ],
  [LANDING_INSTANT_OFFER_PAGE_NAME]: [LANDING_INSTANT_OFFER_PATTERN],
  // web_seller_instant_offer_landing_test
  [LANDING_INSTANT_OFFER_TEST_PAGE_NAME]: [LANDING_INSTANT_OFFER_TEST_PATTERN],
  [INSTANT_OFFER_SELL_TO_DEALER_PAGE_NAME]: [INSTANT_OFFER_SELL_TO_DEALER_PATTERN],
  [INSTANT_OFFER_STANDALONE_PAGE_NAME]: [INSTANT_OFFER_STANDALONE_PATTERN],
  [VEHICLE_APPRAISER_PAGE_NAME]: [VEHICLE_APPRAISER_PATH_PATTERN],
  [RESERVATION_C2B_USER_FORM_PAGE_NAME]: [RESERVATION_C2B_USER_FORM_PATH_PATTERN],
  [RESERVATION_USER_RETURNS_FROM_RAPIDPAY_PAGE_NAME]: [RESERVATION_B2C_USER_RETURNS_FROM_RAPIDPAY_PATH_PATTERN]
}

/**
 * We can not have patterns with route params
 */
export const PAGES_WITHOUT_ADS = [
  CHECKOUT_ACTIVATION_ERROR_PATH_PATTERN,
  CHECKOUT_ERROR_PATH_PATTERN,
  CHECKOUT_PATH_PATTERN,
  CHECKOUT_PENDING_PATH_PATTERN,
  CHECKOUT_REFUND_ERROR_PATH_PATTERN,
  CHECKOUT_REQUEST_ERROR_PATH_PATTERN,
  CHECKOUT_UNKNOWN_ERROR_PATH_PATTERN,
  CHECKOUT_SUCCESS_PATH_PATTERN,
  INSTANT_OFFER_SELL_TO_DEALER_PATTERN,
  INSTANT_OFFER_STANDALONE_PATTERN,
  INSURANCE_PATH,
  LANDING_INSTANT_OFFER_PATTERN,
  // web_seller_instant_offer_landing_test
  LANDING_INSTANT_OFFER_TEST_PATTERN,
  LOGIN_PATH_PATTERN,
  MAKE_PATH_PATTERN,
  MAKES_SIZES_DISTRIBUTOR_PATH_PATTERN,
  MOBILE_PAGES_PATH_PATTERN,
  MODEL_DETAIL_INTERIOR_PATH_PATTERN_REGEX,
  MODEL_DETAIL_PATH_PATTERN_REGEX,
  MODEL_DETAIL_TRUNK_PATH_PATTERN_REGEX,
  OTHER_PARTNERS_PATH_PATTERN,
  PAYMENT_AD_REQUEST_PATH_PATTERN,
  PRIVATE_WALLET_PATH_PATTERN,
  PRODUCTS_PATH_PATTERN,
  PROFESSIONALS_PATH_PATTERN,
  PROFESSIONAL_STOCK_WITH_ID_REGEX,
  PROFESSIONAL_STOCK_RENTING_WITH_REGEX,
  PTA_WITH_PLATE_PATH_PATTERN,
  MY_ADS_PATH_PATTERN,
  PUBLISH_MY_AD_PATH_PATTERN,
  PUBLISH_MY_AD_CATEGORY_PATH_PATTERN,
  EDIT_MY_AD_PATH_PATTERN,
  EDIT_MY_AD_OTHER_CATEGORIES_PATH_PATTERN,
  PUBLISH_YOUR_VEHICLE_PATH_PATTERN,
  PUBLISH_YOUR_VEHICLE_PATH_PATTERNS,
  RATING_PATH_PATTERN,
  COMPARATOR_PATH_PATTERN,
  NET_PATH_PATTERN,
  RECOMMENDATIONS_PATH_PATTERN,
  RESERVATION_C2B_USER_FORM_PATH_PATTERN,
  RESERVATION_PATH_PATTERN,
  RESERVATION_PAYMENT_PATH_PATTERN,
  SELLER_SECURE_PAYMENT_BENEFITS_PATH_PATTERN,
  TERMS_OF_SERVICE_PATH_PATTERN,
  TRANSACTION_PATTERN,
  USER_ACCOUNT_TAKE_OUT_PATTERN,
  USER_DISCOUNTS_PATH_PATTERN,
  USER_FAVORITE_ADS_PATH_PATTERN,
  USER_FAVORITE_DEALERS_PATH_PATTERN,
  USER_MESSAGES_PATH_PATTERN,
  USER_PHONE_VERIFICATION_PATTERN,
  USER_PROFILE_COMPLETE_PURCHASE_PATTERN,
  USER_PROFILE_COMPLETE_RESERVATION_PATTERN,
  USER_PROFILE_EDIT_PATTERN,
  USER_PROFILE_PATTERN,
  USER_SAVED_SEARCHES_PATH_PATTERN,
  USER_ALERTS_MATCHES_PATH_PATTERN,
  USER_UNSUBSCRIBE_SAVED_SEARCHES_PATH_PATTERN,
  USER_UNSUBSCRIBES_EMAILS_PATH_PATTERN,
  VEHICLE_APPRAISER_PATH_PATTERN,
  VEHICLE_CONFIGURATOR_PATH_PATTERN,
  VEHICLE_SUGGESTER_PATH_PATTERN_REGEX,
  VEHICLE_CONFIGURATOR_PATH_PATTERN_REGEX
]

export const CAPTCHA_ORIGINS = {
  AD_DETAIL_CONTACT: 'AdDetailContact',
  MODEL_DETAIL_CONTACT: 'ModelDetailContact'
}

export const CAPTCHA_ORIGINS_BY_PAGENAME = {
  [ADS_DETAIL_PAGE_NAME]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT,
  [MODEL_DETAIL_PAGE_NAME]: CAPTCHA_ORIGINS.MODEL_DETAIL_CONTACT,
  [PROFESSIONAL_STOCK_PAGE_NAME]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT
}

export const MODEL_DETAIL_DEALERSHIP_CONTEXT = 'ModelDetailDealershipContext'
export const MODEL_DETAIL_OEM_CONTEXT = 'ModelDetailOEMContext'

export const CAPTCHA_ORIGINS_BY_CONTEXT = {
  [MODEL_DETAIL_DEALERSHIP_CONTEXT]: CAPTCHA_ORIGINS.AD_DETAIL_CONTACT,
  [MODEL_DETAIL_OEM_CONTEXT]: CAPTCHA_ORIGINS.MODEL_DETAIL_CONTACT
}

export const PAGES_WITH_PRICE_DROP = [USER_FAVORITE_ADS_PAGE_NAME]

// Define only the paths that are different from the common ones
export const PAGE_NAMES_BY_LISTING_SECTION_ID = {
  ...sharedPageNamesByListingSectionId,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: sharedAdsListPageNames.MAIN
}

export const AD_DETAIL_RESERVATION_HASHES = sharedAdDetailReservationHashes
